import React from 'react';
import styled from 'styled-components';
import Router from './Components/Router';
import Context from './Context';
import useVideoData from './API/useVideoData';

const Background = styled.div`
  display: flex;
  height: 100%;
  background-color: #2300e2;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

function App() {
  const context = useVideoData();

  return (
    <Background>
      <Context.Provider value={context}>
        <Router />
      </Context.Provider>
    </Background>
  );
}

export default App;
